export default __webpack_public_path__ + "static/media/view08.c06ff295.jpg";